import styled from "styled-components";

export const SearchBtnWrapper = styled.div`
  width:126px;
`;

export const ActionWrapper = styled.div`
  font: normal normal medium 16px/20px Quicksand;
  letter-spacing: 0px;
  &:hover {
    cursor: pointer;
  }
`;

export const PositiveAction = styled.span`
  color: #006f35;
  margin-right: 5px;
`;

export const NegativeAction = styled.span`
  color: #e80000;
  margin-left: 5px;
`;

export const DialogContentWrapper = styled.div`
  width: 100%;
  margin: auto;
  text-align: center;
  color: ${({ theme }) => {
    return theme.colors.green;
  }};
`;

export const IconWrapper = styled.div`
  font-size: 40px;
  color: ${({ type, theme }) => {
    return type === "success" ? theme.colors.green : theme.colors.red;
  }};
`;

export const MiniModalContentTitle = styled.div`
  text-align: center;
  font: normal normal 600 18px/24px Open Sans;
  letter-spacing: 0px;
  color: ${({ type, theme }) => {
    return type === "success" ? theme.colors.green : theme.colors.red;
  }};
`;

export const MiniModalContentBody = styled.div`
  padding: 10px 0px;
  text-align: center;
  font: normal normal normal 16px/20px Helvetica Neue;
  letter-spacing: 0px;
  color: ${({ theme }) => {
    return theme.colors.darkgrey;
  }};
`;
